export enum UsuarioActionTypeEnum {
    SET_USUARIO = "SET_USUARIO"
}
